<template>
  <div class="column" :class="{'is-6': !detail, 'is-12 is-paddingless': detail}">
    <div class="card height-100">
      <header class="header-card">
        <p> {{ $t('societes.client.defaultValueClient') }} </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-6">
            <b-field
              v-if="detail"
              :label="$t('societes.client.settlementMode')"
              custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold">
                {{ getModeReglement() }}
              </span>
            </b-field>
            <b-field v-else :label="$t('societes.client.settlementMode')">
              <b-select v-model="societe.modeReglementId" expanded>
                <option :value="null"></option>
                <option
                  v-for="modeReglement in modesReglement"
                  :key="modeReglement.id"
                  :value="modeReglement.id">
                  {{modeReglement.libelle}}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field
              v-if="detail"
              :label="$t('societes.client.settlementPeriod')"
              custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold">
                {{ getDelaisReglement() }}
              </span>
            </b-field>
            <b-field v-else :label="$t('societes.client.settlementPeriod')">
              <b-select v-model="societe.delaiReglementId" expanded>
                <option :value="null"></option>
                <option
                  v-for="delai in delaisReglement"
                  :key="delai.id"
                  :value="delai.id">
                  {{delai.libelle}}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field
              v-if="detail"
              :label="$t('societes.client.factureParMail')"
              custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold">
                {{ societe.factureParMail ? $t('general.oui') : $t('general.non') }}
              </span>
            </b-field>
            <b-field v-else class="has-text-default">
              <b-checkbox v-model="societe.factureParMail">
                {{ $t('societes.client.factureParMail')}}
              </b-checkbox>
            </b-field>
          </div>
          <div class="column is-6" v-if="moduleStockTiersActive">
            <b-field
              v-if="detail"
              :label="$t('societes.client.lieuStockageDefault')"
              custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold">
                {{ societe.lieuStockageDefault ? $t('general.oui') : $t('general.non') }}
              </span>
            </b-field>
            <b-field v-else class="has-text-default">
              <b-checkbox v-model="societe.lieuStockageDefault">
                {{ $t('societes.client.lieuStockageDefault')}}
              </b-checkbox>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'gestionClient',
  props: {
    societe: {
      required: true,
      type: Object,
    },
    detail: Boolean,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    delaisReglement() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.delaiReglement);
    },
    modesReglement() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.modeReglement);
    },
    moduleStockTiersActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    getModeReglement() {
      if (!this.societe.modeReglementId) return '';
      const find = this.modesReglement
        .find(el => el.id === this.societe.modeReglementId);
      return find?.libelle || '';
    },
    getDelaisReglement() {
      if (!this.societe.delaiReglementId) return '';
      const find = this.delaisReglement
        .find(el => el.id === this.societe.delaiReglementId);
      return find?.libelle || '';
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.delaiReglement,
        typesParametres.PARAMETRES_KEYS.modeReglement,
      ]);
      await this.loadParametresInterne([
        typesParametres.PARAMETRES_INTERNE_KEYS.moduleStockTiers.key]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
